/*
 * ml-anuncio.js
 * ------------------------------------------------------------------
 * MANTIENE AL DIA EL TEXTO DE LA BARRA DE ANUNCIO, y no hace nada mas.
 *
 * Con la cesta llena, el primer anuncio dice el progreso hacia el envio
 * gratis en vez de la promesa. Ese texto lo escribe Liquid
 * —snippets/ml-envio-estado.liquid— en la carga de la pagina, y ahi esta el
 * problema: la tienda tiene el carrito en cajon, asi que la cesta cambia
 * SIN recargar. Sin este guion, el anuncio se quedaria clavado diciendo «te
 * faltan 5,00 €» mientras el cliente ya ha añadido el segundo producto. Un
 * numero que miente es peor que no decir nada.
 *
 * COMO SE REFRESCA, Y POR QUE ASI. Se le vuelve a pedir la seccion entera a
 * Shopify con la Section Rendering API y se copia el texto que devuelve.
 * Podria calcularse en JavaScript, y seria una peticion menos, pero habria
 * que escribir aqui DOS cosas que ya estan escritas en otro sitio: el
 * formato de moneda de la tienda —que pone el simbolo delante, «€5,00», y
 * no es el que da Intl por defecto— y las dos frases traducidas. Las dos
 * acabarian divergiendo del carrito. Asi manda Liquid y aqui no hay ni una
 * cadena de escaparate ni una regla de formato.
 *
 * AL EVENTO SE LE PREGUNTA EN LA RAIZ. «shopify:cart:lines-update» es un
 * evento estandar de Shopify, no un CustomEvent: «action», «lines» y
 * «promise» viven en el evento y no en «detail». Aqui no se filtra por
 * «action» a proposito —añadir, quitar y cambiar cantidad cambian el total
 * los tres— pero el contrato es el mismo que vigila la prueba N29.
 *
 * NI UNA PROMESA SIN DUEÑO. Todo lleva su «catch», que es la leccion del
 * 26/08/2026: un rechazo sin dueño no rompe nada, no sale por «pageerror» y
 * aun asi lo cuenta Clarity como error. Lo vigila N19.
 */
(function () {
  "use strict";

  var ESPERA = 120;

  function textoDe(raiz) {
    return raiz ? raiz.querySelector("[data-ml-anuncio-texto]") : null;
  }

  /* Vuelve a pedir la seccion y copia el texto. Si algo falla —red caida,
     respuesta rara, la seccion ya no esta— se deja lo que hubiera: un
     anuncio viejo es feo, pero una barra vacia o un error en consola en
     todas las paginas de la tienda es peor. */
  function refrescar(caja) {
    var id = caja.getAttribute("data-ml-anuncio-seccion");
    if (!id) return;

    /* SE PIDE DESDE LA RAIZ, NUNCA DESDE LA PAGINA EN LA QUE ESTAMOS, y esto
       esta medido, no supuesto. En una URL de coleccion el parametro
       «sections» se lo queda la propia coleccion: pidiendo
       «/collections/tienda?sections=sections--…__header_announcements_9jGBFp»
       Shopify contesta 200 con {"collection": …} y se salta la seccion que se
       le ha pedido. Desde «/» devuelve lo que se le pide, con su clave. Y la
       raiz sale de routes.root_url y no de una barra escrita aqui, porque la
       tienda tiene el ingles publicado y ahi la raiz es «/en». */
    var raiz = caja.getAttribute("data-ml-anuncio-raiz") || "/";
    if (raiz.charAt(raiz.length - 1) !== "/") raiz += "/";
    var url = raiz + "?sections=" + encodeURIComponent(id);
    fetch(url, { headers: { Accept: "application/json" } })
      .then(function (r) {
        if (!r.ok) return null;
        return r.json();
      })
      .then(function (datos) {
        if (!datos) return;
        var html = datos[id];
        if (!html) return;

        var doc = new DOMParser().parseFromString(html, "text/html");
        var nuevo = textoDe(doc);
        var actual = textoDe(caja);
        if (!nuevo) return;
        if (!actual) return;
        if (actual.innerHTML === nuevo.innerHTML) return;
        actual.innerHTML = nuevo.innerHTML;
      })
      .catch(function () {
        /* Sin dueño no se queda ninguna. Y sin console.warn: esto corre en
           todas las paginas y un aviso por cada cambio de carrito llena la
           consola de quien esta depurando otra cosa. */
      });
  }

  function atar(caja) {
    if (caja.dataset.mlAnuncioAtado === "si") return;
    caja.dataset.mlAnuncioAtado = "si";

    /* Un solo reloj por barra: al vaciar la cesta linea a linea llegan varios
       eventos seguidos y sin esto se pedirian tres secciones para pintar la
       misma frase. */
    var reloj = null;
    function pedir() {
      window.clearTimeout(reloj);
      reloj = window.setTimeout(function () {
        refrescar(caja);
      }, ESPERA);
    }

    document.addEventListener("shopify:cart:lines-update", function (e) {
      /* ══════════════════════════════════════════════════════════════
         SE ESPERA A LA PROMESA DEL EVENTO, Y ESTO NO ES PRUDENCIA: ES LA
         DIFERENCIA ENTRE FUNCIONAR Y NO FUNCIONAR.

         El evento se dispara ANTES de que el carrito haya cambiado. Se ve en
         assets/component-cart-items.js: primero el dispatchEvent y DESPUES el
         fetch a /cart/change. O sea que quien reaccione al evento a secas le
         pregunta al servidor por una cesta que todavia es la de antes, y
         pinta el numero viejo. Medido el 04/09/2026 con el boton «+» de la
         cesta: la barra de la cesta pasaba a «Envio gratis conseguido» y la de
         arriba se quedaba en «Te faltan 5,00 €».

         «promise» viaja en la RAIZ del evento, no en «detail»: es un evento
         estandar de Shopify y no un CustomEvent. Es el mismo contrato que
         vigila N29 y el mismo que usa assets/cart-icon.js para la burbuja.

         Si la promesa se rompe —la peticion fallo, el cliente cerro la
         pestana— se refresca igual: la cesta se habra quedado como estaba y
         volver a preguntar devuelve justo eso. Lo que no se hace nunca es
         dejarla sin dueño, que es la leccion del 26/08/2026 y lo que vigila
         N19. ══════════════════════════════════════════════════════════════ */
      if (e) {
        if (e.promise) {
          if (typeof e.promise.then === "function") {
            e.promise.then(pedir, pedir);
            return;
          }
        }
      }
      pedir();
    });
  }

  function init(raiz) {
    var cajas = (raiz || document).querySelectorAll("[data-ml-anuncio]");
    for (var i = 0; i < cajas.length; i++) atar(cajas[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(document); });
  } else {
    init(document);
  }

  /* El editor de temas monta y desmonta secciones sin recargar. */
  document.addEventListener("shopify:section:load", function (e) {
    init(e.target || document);
  });
})();
